/**
 * Cleans the endpoint so it's compatible with our vertical interceptor endpoint logic.
 * @param url The endpoint from the BFF with type 'link' and style 'paginate'
 * @returns The cleaned endpoint string.
 */
export function cleanUrlFromApi(url: string) {
  const cleanUrl = /^\/api\//.test(url) && url.replace('/api/', '')
  return cleanUrl || url
}
